import { Editor } from "@tiptap/react";
import { EditorMatch, MatchesEntity } from "../../model/languagetool/types";
import "./SuggestionBox.scss"
import { FloatingDialogComponent } from "./FloatingDialogComponent";
import { getMaxSuggestions } from "../../model/languagetool/MatchesRepository";
import { DisableRule } from "./DisableRule"
import { Mode } from "../../config/types";
import { diffChars } from "diff";

interface SuggestionBoxProps {
    editor : Editor
    currentMatch: EditorMatch
    replace: (arg0: string) => void
    clean: () => void
    close: () => void
    mode: Mode
}

const SuggestionBox = ({editor, mode, currentMatch, replace, clean, close} : SuggestionBoxProps) => {

    if (!editor) {
        return <></>
    }

    return (      
        <FloatingDialogComponent
            className="match-popup"
            updateDelay={50}
            tippyOptions={{ duration: 150, arrow: true, maxWidth: 400 }}
            editor={editor}
            shouldShow={mode === "SpellCheck" && currentMatch.isValid()}
            matchId={currentMatch.id}
        >
            <div role="tooltip">
                <PopupContent currentMatch={currentMatch} replace={replace} clean={clean} close={close} />
            </div>
      </FloatingDialogComponent>
      )
}

const MoreInfo = ({ url } : { url: string }) => {
    return (<a href={url} target="_moreInfo" className="match-popup-more-info-icon" title="Més informació">
        i
    </a>)
}

type PopupContentProps = { 
    currentMatch: EditorMatch
    replace: (s: string) => void
    clean: () => void
    close: () => void
}

const PopupContent = ({ currentMatch, replace, clean, close } : PopupContentProps) => {
    
    if (!currentMatch.isValid() || currentMatch.segment?.segmentType !== "SpellCheck" ) {
        return <></>
    }

    const match = currentMatch.segment as MatchesEntity
    const originalText = match.context.text.substring(match.context.offset, match.context.offset + match.context.length)
    const url = match.rule.urls?.length ? match.rule.urls[0].value : false;


    const maxSuggestions = getMaxSuggestions(match.rule)
    
    return(
        <>
            <div className="match-popup">
            <button className="match-popup-close" onClick={close}>×</button>
            <div className="match-popup-description">
                {match.message}
                { url && <MoreInfo url={url} /> }
            </div>

            <div className="match-popup-actions">
                {match.replacements?.slice(0, maxSuggestions).map((replacement, index) => {
                const isDeletion = replacement.value === "";
                return (
                    <button
                        key={`${currentMatch.id}-${index}`}
                        className={`match-popup-action ${isDeletion ? 'match-popup-action-delete' : ''}`}
                        data-replacement={replacement.value}
                        onClick={() => { 
                            replace(replacement.value) 
                        }}
                    >
                    {isDeletion ? "Suprimeix" : <DiffHighlight original={originalText} suggestion={replacement.value} />}
                    </button>
                )
                })}
                <DisableRule currentMatchId={currentMatch.id} clean={clean} />
            </div>
            </div>
            <div className="popup-arrow" data-popper-arrow></div>
        </>
    )
}

export { SuggestionBox }
const DiffHighlight = ({ original, suggestion }: { original: string, suggestion: string }) => {
    const diffResults = diffChars(original, suggestion);
    return (
        <>
            {diffResults.map((part, index) => {
                if (part.removed) return null;
                return (
                    <span key={index} style={{ fontWeight: part.added ? 'bold' : 'normal' }}>
                        {part.value}
                    </span>
                );
            })}
        </>
    );
};
